import * as React from 'react';

import { logging } from '../../logging';

export default <T>(key: string, initialValue: T | (() => T)): [T, (value: T) => void] => {
	// tslint:disable-next-line: ban-types
	const isFunction = (arg: any): arg is Function => typeof arg === 'function';

	const [storedData, setStoredData] = React.useState<T>(() => {
		const init = isFunction(initialValue) ? initialValue() : initialValue;
		try {
			const item = window.localStorage.getItem(key);
			return item ? JSON.parse(item) : init;
		} catch (error) {
			logging.error(error);
			return init;
		}
	});

	const setValue = (value: T | (() => T)) => {
		try {
			const v = isFunction(value) ? value() : value;
			setStoredData(v);
			window.localStorage.setItem(key, JSON.stringify(v));
		} catch (error) {
			logging.error(error);
		}
	};

	return [storedData, setValue];
};
